import { ActionLink } from '@klp/design/Action';
import { ProsjektRoutes } from '@klp/prosjekt/config';
import React from 'react';
import { useHistory } from 'react-router';
import { useProsjektSammendragContext } from './context/ProsjektSammendragProvider';

export const ProsjektSammendragNavigation: React.FC = () => {
    const { invalidateProcess } = useProsjektSammendragContext();

    const history = useHistory();

    const handleBackNavigation = () => {
        invalidateProcess();
        history.push(ProsjektRoutes.projectSchema());
    };

    return (
        <ActionLink
            actionType="linkBack"
            translation="project.backButton"
            onClick={handleBackNavigation}
            href={ProsjektRoutes.projectSchema()}
        />
    );
};
